<template>
<div class="routeDetailImages">
  <swiper ref="bannerSwiper" class="routeDetailSwiper" :options="swiperOption"
          @slideChange="onSlideChange()" style="padding: 0">
    <swiper-slide v-for="(x, idx) in bannerList" :key="idx"
                  class="routeDetail-image" style="width: 335px;">
<!--      x.bannerType 0--图片 1--视频-->
      <img v-if="x.bannerType!==1" :src="x.wechatMiniProgramBannerImage" alt="">
<!--      <video v-else :src="x.wechatMiniProgramBannerImage" controls :poster="x.wechatVideoImage"></video>-->
      <div v-else style="width: 100%">
        <Destination-video :coverUrl="x.wechatVideoImage"
                           :videoUrl="x.wechatMiniProgramBannerImage"
                           :is-white-btn="true"
                           @onChangeVideo="onChangeVideoPlay"
                           :shorexBannerIndex="`${shorexIndex}_${idx}`"
        ></Destination-video>
      </div>
    </swiper-slide>
  </swiper>
  <div class="swiper-dots" v-if="bannerList.length>1">
    <span id="cruiseDetailBannerIndex"
          class="dots-item"
          :class="{'active': idx === bannerIndex}"
          v-for="(x,idx) in bannerList"
          :key="idx">
    </span>
  </div>
</div>
</template>
<script>
import {Swiper,SwiperSlide} from "vue-awesome-swiper";
import DestinationVideo from "@/components/alert/DestinationVideo.vue";
export default {
  name: "ShorexSwiper",
  components: {
    DestinationVideo,
    Swiper,
    SwiperSlide
  },
  props: {
    bannerList: {
      type: Array,
      default: () => {
        return []
      }
    },
    shorexIndex:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      swiperOption: {
        loop: false,
        speed: 500,
        autoplay: true,
      },
      bannerIndex:0
    }
  },
  methods: {
    onSlideChange(){
      let swiper = this.$refs.bannerSwiper.$swiper
      this.bannerIndex = swiper.realIndex
    },
    onChangeVideoPlay(){
      let swiper = this.$refs.bannerSwiper.$swiper
      swiper.autoplay.stop()
    }
  }
}
</script>

<style scoped lang="less">
.routeDetailImages{
  width: 100%;
  height: 100%;
  position: relative;
  & .swiper-dots{
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    & .dots-item{
      width: 8px;
      height: 8px;
      background: #fff;
      border-radius: 50%;
    }
    & .dots-item.active{
      background: #e3b340;
    }
  }
  & img{
    width: 100%;
    height: 100%;
  }
  & video{
    width: 100%;
    height: 100%;
    object-fit: inherit;
  }
  .routeDetailSwiper{
    width: 100%;
    height: 100%;
  }
}
</style>